
import { memo } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { HOW_IT_WORKS_KEYS } from '@/constants/translations';

const HowItWorksSection = memo(() => {
  const { t } = useLanguage();

  const steps = [
    {
      number: 1,
      title: t(HOW_IT_WORKS_KEYS.SEARCH.TITLE),
      description: t(HOW_IT_WORKS_KEYS.SEARCH.DESCRIPTION)
    },
    {
      number: 2,
      title: t(HOW_IT_WORKS_KEYS.BOOK.TITLE),
      description: t(HOW_IT_WORKS_KEYS.BOOK.DESCRIPTION)
    },
    {
      number: 3,
      title: t(HOW_IT_WORKS_KEYS.ENJOY.TITLE),
      description: t(HOW_IT_WORKS_KEYS.ENJOY.DESCRIPTION)
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t(HOW_IT_WORKS_KEYS.TITLE)}
          </h2>
          <p className="text-xl text-gray-600">
            {t(HOW_IT_WORKS_KEYS.SUBTITLE)}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step) => (
            <div key={step.number} className="text-center">
              <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
                <span className="text-2xl font-bold text-brand-primary">{step.number}</span>
              </div>
              <h3 className="text-xl font-semibold mb-4">{step.title}</h3>
              <p className="text-gray-600">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
});

HowItWorksSection.displayName = 'HowItWorksSection';

export default HowItWorksSection;
